/*
 * IMPORTS
 */
import React from 'react' // Npm: react.js library.
import PropTypes from 'prop-types' // Npm: react.js library.
import _ from 'underscore' // Npm: Underscore.js library.
import { connect } from 'react-redux' // Npm: React Redux for state management.
import { useMutation } from '@apollo/client' // Npm: Apollo client.
import { toast } from 'react-hot-toast' // Npm: React hot toast.


/*
 * SIBLINGS
 */
import DeleteCard from 'components/DeleteCard'


/*
 * GRAPHS
 */
import PhoneNumberReplacementServiceDeleteMany from './__mutation__/index.phoneNumberReplacementService.delete.mutation'


/*
 * OBJECTS
 */
const Index = ({ passOn, onClose, refetch }) => {
  // Hook assignment.
  const [MutationPhoneNumberReplacementServiceDelete, MutationPhoneNumberReplacementServiceDeleteResponse] = useMutation(PhoneNumberReplacementServiceDeleteMany)

  // Return Component.
  return (
    <DeleteCard
      onClose={onClose}
      disabled={MutationPhoneNumberReplacementServiceDeleteResponse.loading}
      onConfirm={() => MutationPhoneNumberReplacementServiceDelete({
        'variables': {
          'phoneNumberoReplacementIds': _.compact(passOn?.phoneNumberReplacementServiceIds ?? [passOn?.phoneNumberReplacementServiceId])
        }
      }).then(async i => {
        // Style Guide.
        toast(i?.data?.PhoneNumberoReplacementDeleteMany?.message)

        // Refetch list after delete so table reflects latest data.
        await refetch?.()
        return onClose?.()
      }).catch(() =>
        // Style Guide.
        toast('Something went wrong please try after some time.'))}
      isLoading={MutationPhoneNumberReplacementServiceDeleteResponse.loading} />
  )
}


/*
 * PROPTYPES
 */
Index.propTypes = {
  'passOn': PropTypes.object,
  'onClose': PropTypes.func,
  'refetch': PropTypes.func
}


/*
 * REDUX
 */
const _MapStateToProps = __state => ({ 'passOn': __state.PassOn })


/*
 * EXPORT
 */
export default connect(_MapStateToProps)(Index)
